<template>
  <div
    v-if="cdata.length"
    class="right-top"
    style="transform-origin: 0px 0px; height: 240px; width: 484px"
    :style="`transform: scale(${sscale})`"
  >
    <v-chart :forceFit="true" :height="height" :data="cdata" :scale="scale" :padding="[20, 130, 20, 30]">
      <v-tooltip :showTitle="false" dataKey="item*percent" />
      <v-axis />
      <v-legend dataKey="item" position="right" />
      <v-pie position="percent" color="item" :vStyle="pieStyle" :label="labelConfig" />
      <v-coord type="theta" :radius="0.75" :innerRadius="0.6" />
    </v-chart>
  </div>
</template>

<script>
const DataSet = require('@antv/data-set')

export default {
  props: {
    dongbi: {
      default() {
        return []
      },
    },
  },
  mounted() {
    this.sscale = window.innerWidth / 1920

    this.$nextTick(() => {
      const sourceData = this.dongbi

      const scale = [
        {
          dataKey: 'percent',
          min: 0,
          formatter: '.0%',
        },
      ]

      const dv = new DataSet.View().source(sourceData)
      dv.transform({
        type: 'percent',
        field: 'count',
        dimension: 'item',
        as: 'percent',
      })
      const data = dv.rows

      this.cdata = data
      this.scale = scale
    })
  },
  data() {
    return {
      sscale: 1,
      cdata: [],
      scale: [],
      height: 240,
      pieStyle: {
        stroke: '#82A9EF',
        lineWidth: 1,
      },
      labelConfig: [
        'percent',
        {
          formatter: (val, item) => {
            return item.point.item + ': ' + val
          },
          textStyle: {
            fill: '#82A9EF',
          },
        },
      ],
    }
  },
}
</script>
